module.exports = __webpack_public_path__ + "static/media/PC4-2-2.079ec3d7.jpg";